
import React, { Component, Fragment, useEffect, useState, useContext } from "react";
import { SessionContext } from "../../../context/SessionProvider";

import useFetch from "../../helpers/useFetch";
import BiButton from "../../uic/controls/BiButton";
import BiLabel from "../../uic/controls/BiLabel";
import BiDataGrid from "../../uic/dataGrid/BiDataGrid"
import { Link, useNavigate } from 'react-router-dom';
import InfoBoxStranka from "./InfoBoxStranka";
import { NavLink } from "../../../../node_modules/react-router-dom/index";

const DomovStranka = (props) => {
    const navigate = useNavigate();

    const { sessionReady, setLoading, toastError, toastOK, setHelpMainKey } = useContext(SessionContext)
    const { data: stranka, setUrl: setStrankaURL, isLoaded } = useFetch(null);

    useEffect(() => {
        if (sessionReady) {
            setLoading(true);
            setStrankaURL('api/stranke/GetStankaInfo');
        }
    }, [sessionReady])
    useEffect(() => { setLoading(false); }, [isLoaded]);

    return (

        <Fragment >
            {stranka && 
                <Fragment>

                    <div>

                        <div className="row" >
                            <div className="col-md-8">
                                <h2>Dobrodošel {stranka.naziv}</h2>
                                <br></br>
                                <p><b>Pozdravljeni na spletnem portalu Inštituta KON-CERT</b></p>

                                <p>Na spletnem portalu si lahko ogledate:</p>
                                <ul>
                                    <li>Vaše osebne podatke</li>
                                    <li>Izpolnite <NavLink tag={Link}  to="/obrazciStranka">obrazce</NavLink></li>
                                    {/*<li>Prenesete vaše <NavLink tag={Link} to="/certifikatiStranka">certifikate</NavLink></li>*/}
                                </ul>
                                <p><b>Navodila:</b></p>
                                <ul>
                                    <li>Kliknite na gumb "Obrazci" ali povezavo <NavLink tag={Link} to="/obrazciStranka">obrazci</NavLink></li>
                                    <li>Na strani "Seznam vseh obrazcev" kliknite na gumb "Odpri obrazec" in odprl se vam bo obrazec</li>
                                    {/*<li>Prenesete vaše <NavLink tag={Link} to="/certifikatiStranka">certifikate</NavLink></li>*/}
                                    <li>S klikom na gumb "Podpiši in pošlji" boste oddali obrazec</li>
                                </ul>
                            </div>
                            <div className="col-md-4">
                                <InfoBoxStranka stranka={stranka} ></InfoBoxStranka>
                             
                            </div>
                        </div>

                    </div>

                </Fragment>
            
            }
        </Fragment>   
    );

}

export default DomovStranka;